module.exports = __webpack_public_path__ + "static/media/banner.64eee596.png";